var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60449 15.5834L0.583659 8.58341C0.500326 8.50008 0.441437 8.4098 0.406992 8.31258C0.371992 8.21536 0.354492 8.11119 0.354492 8.00008C0.354492 7.88897 0.371992 7.7848 0.406992 7.68758C0.441437 7.59036 0.500326 7.50008 0.583659 7.41675L7.60449 0.395915C7.79894 0.20147 8.04199 0.104248 8.33366 0.104248C8.62533 0.104248 8.87533 0.208415 9.08366 0.416748C9.29199 0.625081 9.39616 0.868137 9.39616 1.14591C9.39616 1.42369 9.29199 1.66675 9.08366 1.87508L2.95866 8.00008L9.08366 14.1251C9.2781 14.3195 9.37533 14.559 9.37533 14.8434C9.37533 15.1284 9.27116 15.3751 9.06283 15.5834C8.85449 15.7917 8.61144 15.8959 8.33366 15.8959C8.05588 15.8959 7.81283 15.7917 7.60449 15.5834Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.3e95971ea29e0d7c97938e6b317ab769.svg";
export { ForwardRef as ReactComponent };